import { IconMenu2 } from '@tabler/icons-react';
import React, { useEffect, useRef, useState } from 'react';
import SwitchOrganization from '../components/Organization/SwitchOrganization';
import ProfileDropdown from '../components/Profile/ProfileDropdown';
import SideMenu from '../components/SideMenu/SideMenu';
import CandyMenu from '../components/PrductListMenu/CandyMenu';

const Layout = React.memo(({ children }) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992 ? true : false);
    const [isOpen, setIsOpen] = useState(window.innerWidth > 992 ? true : false);
    const sidebarToggle = () => {
        setIsOpen(!isOpen)
    }

    const handleResize = () => {
        if (window.innerWidth < 1100) {
            setIsMobile(true);
            setIsOpen(false)
        } else {
            setIsMobile(false);
            setIsOpen(true);
        }
    }

    useEffect(() => {
        window.addEventListener("resize", handleResize);
    }, []);

    const [isScrolled, setIsScrolled] = useState(false);
    const mainContent = useRef(null)

    useEffect(() => {
        const contentDiv = mainContent.current;
        if (contentDiv) {
            contentDiv.addEventListener('scroll', handleScroll);
            return () => {
                contentDiv.removeEventListener('scroll', handleScroll);
            };
        }
    }, []);

    const handleScroll = (e) => {
        if (e.target.scrollTop > 20) {
            setIsScrolled(true);
        } else {
            setIsScrolled(false);
        }
    };

    return (
        <div className="main-container flex relative" id='main-container'>

            <SideMenu isOpen={isOpen} />

            {isMobile && <div className='bg-slate-950 absolute h-screen z-[49] opacity-70'
                style={{ width: isOpen ? "100vw" : '0px', transition: 'all 0.1s ease-in-out' }}
                onClick={() => setIsOpen(false)} />}

            <div className='content-body h-100vh'
                style={{ width: (isOpen && !isMobile) ? 'calc(100vw - 260px)' : '100vw', marginLeft: (isOpen && !isMobile) ? '260px' : '0px', transition: 'all 0.3s ease-in-out' }}>

                <nav className={`fixed top-0 z-[1049] ${isScrolled ? 'bg-[#0F0C22]' : 'bg-transparent'}`}
                    style={{ width: (isOpen && !isMobile) ? 'calc(100vw - 260px)' : '100vw', marginLeft: (isMobile && isOpen) ? '260px' : '0px', transition: 'all 0.3s ease-in-out' }}>
                    <div className="relative flex justify-between global-navbar px-6 py-[8px] bg-white">
                        <button onClick={() => sidebarToggle()}>
                            <IconMenu2 />
                        </button>
                        <div className='flex items-center !gap-3'>
                            {/* <CandyMenu /> */}
                            <SwitchOrganization />
                            <ProfileDropdown />
                        </div>
                    </div>
                </nav>

                <div className="content pt-[65px] !pb-5 h-screen px-4 overflow-y-auto overflow-x-hidden relative" id='mainContent'
                    ref={mainContent}
                    style={{ transition: 'all 0.3s ease-in-out' }}>
                    {children}
                </div>

            </div>

        </div>
    )
})

export default Layout